import { Link, useNavigate } from "react-router-dom";
import { Sun, Moon } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";

export function PublicHeader() {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="public-logo"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          <Link to="/pricing" className="hover:text-foreground transition-colors" data-testid="public-nav-pricing">Pricing</Link>
          <Link to="/demo" className="hover:text-foreground transition-colors" data-testid="public-nav-demo">Request a demo</Link>
        </nav>
        <div className="flex items-center gap-2">
          <button onClick={toggle} data-testid="theme-toggle-button" className="h-9 w-9 rounded-md border border-border/70 flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors">
            {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </button>
          {user ? (
            <Button onClick={() => navigate("/app")} className="rounded-md" data-testid="public-open-app">Open app</Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} className="rounded-md hidden sm:inline-flex" data-testid="public-signin">Sign in</Button>
              <Button onClick={() => navigate("/demo")} className="rounded-md bg-amber-500 text-black hover:bg-amber-400" data-testid="public-demo-cta">Request a demo</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
